module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.b180c799.eot";